import { useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';

import { StatusTag } from '~/components';

type Props = {
  status: 'coPaid' | 'credited' | 'fcPaid' | 'notPaid' | 'partiallyPaid';
};

export const PaymentStatusTag = ({ status }: Props) => {
  const { t } = useTranslation(['invoices']);

  return match(status)
    .with('notPaid', () => (
      <StatusTag icon="HourglassBottom" label={t('invoices:details.paymentInfo.status.options.notPaid')} status="warning" />
    ))
    .with('partiallyPaid', () => (
      <StatusTag icon="Payments" label={t('invoices:overview.columns.substatus.CoPartiallyPaid')} status="info" />
    ))
    .with('coPaid', () => <StatusTag icon="Check" label={t('invoices:details.paymentInfo.status.options.paid')} status="success" />)
    .with('fcPaid', () => <StatusTag icon="Check" label={t('invoices:details.paymentInfo.status.options.fcPaid')} status="success" />)
    .with('credited', () => (
      <StatusTag icon="CreditNote" label={t('invoices:details.paymentInfo.status.options.credited')} status="neutral" />
    ))
    .exhaustive();
};
